import { ContactList } from "@/components/contacts/ContactList.tsx";
import {
  MainContentWrapper,
  SiteHeaderContent,
  ViewWrapper,
} from "@/components/layout/ViewWrapper.tsx";
import { Loader } from "@/components/loader/Loader.tsx";
import { useContactProfilesEnabled } from "@/hooks/useContactProfilesEnabled.ts";
import { useEmbedded } from "@/hooks/useEmbedded.tsx";
import { useEffect } from "react";
import { useLocation } from "wouter";

/**
 * People — the contacts that have a research-backed profile (the "Dossier" work).
 * Same list UI as Contacts, filtered to profiled people via `hasProfile`. Gated by
 * the `contact-profiles` routine enablement (see `useContactProfilesEnabled`): a
 * non-cohort account is redirected home rather than shown an empty list.
 */
export const PeopleListScreen = () => {
  const { enabled, isLoading } = useContactProfilesEnabled();
  const { isWebView } = useEmbedded();
  const [, setLocation] = useLocation();

  useEffect(() => {
    // Only redirect once the enablement query has resolved — never mid-flight.
    if (!isLoading && !enabled) setLocation("/", { replace: true });
  }, [isLoading, enabled, setLocation]);

  const header = (
    <SiteHeaderContent
      includeBackButton={!isWebView}
      title={isWebView ? undefined : "People"}
      hideNav={isWebView}
    />
  );

  if (isLoading) {
    return (
      <ViewWrapper headerContent={header}>
        <MainContentWrapper>
          <Loader />
        </MainContentWrapper>
      </ViewWrapper>
    );
  }

  if (!enabled) return null;

  return (
    <ViewWrapper headerContent={header}>
      <MainContentWrapper className="gap-2">
        <ContactList hasProfile />
      </MainContentWrapper>
    </ViewWrapper>
  );
};
